// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title___65IX"};
module.exports.__checksum = "bc3b63fd018b"